module.exports = __webpack_public_path__ + "img/22n.fc649a2e.png";